import DepartmentSelectV2 from "@/components/DepartmentSelectV2.vue";
import EmployeeSelectV2 from "@/components/EmployeeSelectV2.vue";
import SeasonSelect from "@/components/SeasonSelect.vue";
import TaskTypeSelect from "@/components/TaskTypeSelect.vue";
import { keyTaskTable } from "../data/KeyTaskManage";
import moment from "moment";
import { getSeason } from "../utils/utilApi";
import { post } from "../utils/request";
import { ElMessage } from "element-plus";


export default {
  data() {
    return {
      showable: {
        addKeyTask: false,
        distributeBtn: false,
        distributeForm: false,
      },
      disable: {
        addKeyTaskBtn: false,
        confirmAddBtn: false,
      },
      departmentId: JSON.parse(sessionStorage.getItem("departmentInfo")).departmentId,
      year: moment().format("YYYY"),
      season: getSeason(),
      currentPage: 1,
      pagesize: 10,
      keyTaskTable: [],
      keyTaskList: [],
      taskSelect: [],
      keyTaskForm: {
        taskCategory: "",
        respPerson: "",
        taskDetail: "",
        leaderDept: "",
        evaCriterion: "",
        totalScore: "",
        taskType: 3,
        coDept: "",
        specificPerson: "",
        beginDate: "",
        endDate: "",
        remarks: "",
      },
      selectKeyTask: "",
      distrubuteList: []
    };
  },
  name: "KeyTaskManage",
  methods: {
    // 切换每页显示数据
    handleSizeChange(val) {
      this.pagesize = val;
      // console.log(`每页 ${val} 条`);
    },
    // 切换页面
    handleCurrentChange(val) {
      this.currentPage = val;
      // console.log(`当前页: ${val}`);
    },
    // 表格数据过滤
    formatter(row, column) {
      if (column.property == 'leaderDept') {
        return row.leaderDeptName.join(', ');
      } else if (column.property == 'respPerson') {
        return row.respPersonName.join(', ');
      } else if (column.property == 'coDept') {
        return row.coDeptName.join(', ');
      } else if (column.property == 'specificPerson' && row.specificPerson != null && row.specificPerson != "") {
        return row.specificPersonName.join(', ');
      } else if (column.property == 'distribute') {
        return row.distribute == false ? '否' : '是';
      } else {
        return row[column.property];
      }
    },
    handleEdit(index, row) {
      this.keyTaskForm = this.$options.data().keyTaskForm;
      this.keyTaskForm = row;
      this.disable.confirmAddBtn = true;
      this.showable.addKeyTask = true;
    },
    /**
     * @description 删除关键任务
     * @function POST /keyTask/delete
     * 
     * @param {int} taskId被删除的任务的ID
     * @returns 删除成功
     */
    handleDelete(index, row) {
      post('/keyTask/delete', JSON.stringify({ taskId: row.taskId })).then(res => {
        if (res.code == 200) {
          this.keyTaskList.splice(index, 1);
        }
      });
    },
    handleDistribute(index, row) {
      this.selectKeyTask = row;
      this.searchItem();
      this.showable.distributeForm = true;
    },
    // 表格选择
    handleSelect(val, row) {
      // val是个数组，row是数组中的第一个对象
      this.taskSelect = val;
    },
    handleAdd() {
      this.keyTaskForm = this.$options.data().keyTaskForm;
      this.disable.confirmAddBtn = false;
      this.showable.addKeyTask = true;
    },
    doCancel() {
      this.showable.addKeyTask = false;
    },
    /**
     * @description 添加关键任务
     * @function POST /keyTask/add
     * 
     * @param {String} taskCategory 任务分类
     * @param {int} taskType 任务类型
     * @param {int[]} leaderDept 牵头科室
     * @param {int[]} respPerson 责任人
     * @param {int[]} coDept 配合科室
     * @param {int[]} specificPerson 具体工作人员
     * @param {String} taskDetail 工作内容
     * @param {String} evaCriterion 评价标准
     * @param {Date} beginDate 开始时间
     * @param {Date} endDate 截止时间
     * @param {int} totalScore 总分值
     * @param {String} remarks 备注
     * @param {int} departmentId 局ID
     * @param {int} year 年
     * @param {String} season 季度
     * 
     * @returns 添加成功
     */
    addTask() {
      let data = JSON.parse(JSON.stringify(this.keyTaskForm));
      data.departmentId = this.departmentId;
      data.year = this.year;
      data.season = this.season;
      post('/keyTask/add', JSON.stringify(data)).then(res => {
        if (res.code == 200) {
          // this.keyTaskForm.taskId = JSON.parse(res.data.taskId);
          // 重新查询一遍
          this.searchTask();
          this.showable.addKeyTask = false;
        }
      });
    },
    /**
     * @description 查询当局所有关键任务
     * @function POST /keyTask/search
     * 
     * @param {int} year 年
     * @param {String} season 季度
     * @param {int} departmentId 局ID
     * 
     * @return 数据库中所有属性
     */
    searchTask() {
      let data = {
        year: this.year,
        season: this.season,
        departmentId: this.departmentId
      }
      post('/keyTask/search', JSON.stringify(data)).then(res => {
        if (res.code == 200) {
          this.keyTaskList = JSON.parse(res.data.keyTaskList);
        }
        if (res.code == 204) {
          this.keyTaskList = [];
        }
      });
    },
    /**
     * @description 任务批量下发，将任务的distribute属性赋值成1
     * @function POST /keyTask/distribute
     * 
     * @param {int[]} taskIdArr 任务ID数组
     * @param {int} departmentId
     * @returns 成功
     */
    doDistribute() {
      if (this.taskSelect.length == 0) {
        ElMessage.warning("请先选择需要下发的关键任务", {
          duration: 3 * 1000,
        });
        return;
      }
      let taskIdArr = [];
      for (let i = 0; i < this.taskSelect.length; i++) {
        taskIdArr.push(this.taskSelect[i].taskId)
      }
      post('/keyTask/distribute', JSON.stringify({ departmentId: this.departmentId, taskIdArr: taskIdArr })).then(res => {
        if (res.code == 200) {
          this.keyTaskList = JSON.parse(res.data.data);
          // 遍历将状态改为已下发
        }
      });
    },
    // 添加具体工作人员信息
    handleAddItem() {
      this.distrubuteList.push({});
    },
    deletePartial(index, row) {
      this.distrubuteList.splice(index, 1);
    },
    /**
     * @description 科室长配置关键任务中各科室成员的得分占比
     * @function POST /keyTask/item/add
     * 
     * @param {int} taskId 关键任务ID
     * @param {int} departmentId 科室ID
     * @param {Object[]} itemList 分配细则集合
     * @param {int} itemList[].specificPerson 具体工作人员
     * @param {int} itemList[].proportion 占比(%)
     * 
     * @returns 设置成功
     */
    addItem() {
      let data = {
        taskId: this.selectKeyTask.taskId,
        itemList: this.distrubuteList,
      };
      post('/keyTask/item/add', JSON.stringify(data)).then(res => {
        if (res.code == 200) {
          console.log('下发成功');
        }
      });
    },
    /**
     * @description 查询科室分配关键任务细则
     * @function POST /keyTask/item/search
     * 
     * @param {int} taskId 关键任务ID
     * @param {int} departmentId 科室ID
     * 
     * @returns R.message(null).data('distrubuteList')，distrubuteList每一项属性如下
     * @returns specificPerson、specificPersonName、proportion
     */
    searchItem() {
      let data = {
        taskId: this.selectKeyTask.taskId,
        departmentId: this.departmentId,
      };
      post('/keyTask/item/search', JSON.stringify(data)).then(res => {
        if (res.code == 200) {
          this.distrubuteList = JSON.parse(res.data.distrubuteList);
        }
      });
    }
  },
  components: { DepartmentSelectV2, EmployeeSelectV2, SeasonSelect, TaskTypeSelect, },
  created() {
    this.keyTaskTable = keyTaskTable;
    let roleList = JSON.parse(sessionStorage.getItem("roleList"));
    for (let i = 0; i < roleList.length; i++) {
      // 关键任务只有局级管理制定，科长只有下发功能
      if (roleList[i].roleId == "107") {
        this.disable.addKeyTaskBtn = true;
        this.showable.distributeBtn = true;
        break;
      }
    }
    this.searchTask();
  },
  watch: {
    year() {
      this.searchTask();
    },
    season() {
      this.searchTask();
    }
  }
};